import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type FetchCalendarDetailQueryVariables = Types.Exact<{
  guid: Types.Scalars['ID']['input'];
}>;


export type FetchCalendarDetailQuery = { __typename?: 'Query', calendarDetail: { __typename?: 'Calendar', guid: string, status: Types.CalendarStatus, privateTitle?: string | null, publicTitle: string, description?: string | null, slotDurationMinutes: number, slotOffsetMinutes: number, slotGenerationDelayHours: number, slotGenerationPeriodDays: number, staffSelectionStrategy: Types.CalendarStaffSelectionStrategy, dailyAvailabilities: Array<{ __typename?: 'CalendarDailyAvailability', dayOfWeek: Types.DayOfWeek, from: { __typename?: 'CalendarTimeOfDay', hours: number, minutes: number }, until: { __typename?: 'CalendarTimeOfDay', hours: number, minutes: number } }>, assignedStaffs: Array<{ __typename?: 'CalendarAssignedStaff', guid: string, priority?: number | null, displayName: string }>, questions: Array<{ __typename: 'CalendarQuestionSelectBox', options: Array<string>, type: Types.CalendarQuestionType, order: number, questionText: string, status: Types.CalendarQuestionStatus } | { __typename: 'CalendarQuestionText', type: Types.CalendarQuestionType, order: number, questionText: string, status: Types.CalendarQuestionStatus }> } };

export type UpdateCalendarMutationVariables = Types.Exact<{
  input: Types.UpdateCalendarInput;
}>;


export type UpdateCalendarMutation = { __typename?: 'Mutation', updateCalendar: { __typename?: 'UpdateCalendarPayload', success: boolean } };

export type DeleteCalendarMutationVariables = Types.Exact<{
  input: Types.DeleteCalendarInput;
}>;


export type DeleteCalendarMutation = { __typename?: 'Mutation', deleteCalendar: { __typename: 'CalendarInUseByScheduleAdjustmentError' } | { __typename: 'DeleteCalendarSuccess' } };


export const FetchCalendarDetailDocument = gql`
    query FetchCalendarDetail($guid: ID!) {
  calendarDetail(guid: $guid) {
    guid
    status
    privateTitle
    publicTitle
    description
    slotDurationMinutes
    slotOffsetMinutes
    slotGenerationDelayHours
    slotGenerationPeriodDays
    dailyAvailabilities {
      dayOfWeek
      from {
        hours
        minutes
      }
      until {
        hours
        minutes
      }
    }
    assignedStaffs {
      guid
      priority
      displayName
    }
    staffSelectionStrategy
    questions {
      __typename
      type
      order
      questionText
      status
      ... on CalendarQuestionSelectBox {
        options
      }
    }
  }
}
    `;

/**
 * __useFetchCalendarDetailQuery__
 *
 * To run a query within a Vue component, call `useFetchCalendarDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCalendarDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchCalendarDetailQuery({
 *   guid: // value for 'guid'
 * });
 */
export function useFetchCalendarDetailQuery(variables: FetchCalendarDetailQueryVariables | VueCompositionApi.Ref<FetchCalendarDetailQueryVariables> | ReactiveFunction<FetchCalendarDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchCalendarDetailQuery, FetchCalendarDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchCalendarDetailQuery, FetchCalendarDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchCalendarDetailQuery, FetchCalendarDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchCalendarDetailQuery, FetchCalendarDetailQueryVariables>(FetchCalendarDetailDocument, variables, options);
}
export function useFetchCalendarDetailLazyQuery(variables?: FetchCalendarDetailQueryVariables | VueCompositionApi.Ref<FetchCalendarDetailQueryVariables> | ReactiveFunction<FetchCalendarDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchCalendarDetailQuery, FetchCalendarDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchCalendarDetailQuery, FetchCalendarDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchCalendarDetailQuery, FetchCalendarDetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchCalendarDetailQuery, FetchCalendarDetailQueryVariables>(FetchCalendarDetailDocument, variables, options);
}
export type FetchCalendarDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchCalendarDetailQuery, FetchCalendarDetailQueryVariables>;
export const UpdateCalendarDocument = gql`
    mutation UpdateCalendar($input: UpdateCalendarInput!) {
  updateCalendar(input: $input) {
    success
  }
}
    `;

/**
 * __useUpdateCalendarMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCalendarMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCalendarMutation(options: VueApolloComposable.UseMutationOptions<UpdateCalendarMutation, UpdateCalendarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCalendarMutation, UpdateCalendarMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCalendarMutation, UpdateCalendarMutationVariables>(UpdateCalendarDocument, options);
}
export type UpdateCalendarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCalendarMutation, UpdateCalendarMutationVariables>;
export const DeleteCalendarDocument = gql`
    mutation DeleteCalendar($input: DeleteCalendarInput!) {
  deleteCalendar(input: $input) {
    __typename
  }
}
    `;

/**
 * __useDeleteCalendarMutation__
 *
 * To run a mutation, you first call `useDeleteCalendarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCalendarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCalendarMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCalendarMutation(options: VueApolloComposable.UseMutationOptions<DeleteCalendarMutation, DeleteCalendarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteCalendarMutation, DeleteCalendarMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteCalendarMutation, DeleteCalendarMutationVariables>(DeleteCalendarDocument, options);
}
export type DeleteCalendarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteCalendarMutation, DeleteCalendarMutationVariables>;